// extracted by mini-css-extract-plugin
export default {"clip":"NavBar_clip__iN8vQ","userFunctionality":"NavBar_userFunctionality__djITV","divider":"NavBar_divider__MOx+c","show":"NavBar_show__5qR-J","hide":"NavBar_hide__ZYLJu"};